<script lang="ts">
	import '@awesome.me/kit-f1d1181ead/icons/css/all.min.css';
	import { page } from '$app/stores';
	import { goto, onNavigate } from '$app/navigation';

	let navLinks = [
		{ link: '/', type: 'text', text: 'Home', id: 'shopMenu' },
		{
			link: '/shop',
			type: 'expandable',
			text: 'Shop',
			urlParam: 'category',
			subLinks: [
				'Layer Cakes',
				'Cupcakes',
				'Other Desserts',
				'Sweet Additions',
				'Pies'
			]
		},

		{ link: '/media', type: 'text', text: 'Media' },
		{ link: '/about', type: 'text', text: 'About' }
	];

	let expandableSections: Array<HTMLDetailsElement> = [];

	onNavigate((url) => {
		expandableSections.forEach((section) => {
			if (section.open) {
				section.removeAttribute('open');
			}
		});
	});
</script>

<nav class="md:hidden">
	<ul class="space-y-1">
		{#each navLinks as link}
			<li>
				{#if link.type == 'text'}
					<a
						class="block border-logoFontGold px-4 py-2 text-sm font-medium hover:text-gray-600 focus:text-gray-600 aria-current:border-y-2"
						href={link.link}
						aria-current={$page.url.pathname === link.link}>{link.text}</a
					>
				{:else if link.type == 'expandable'}
					<details
						bind:this={expandableSections[expandableSections.length]}
						class="group [&_summary::-webkit-details-marker]:hidden"
					>
						<summary
							class="flex cursor-pointer items-center justify-between border-logoFontGold px-4 py-2 hover:text-gray-600 focus:text-gray-600 aria-current:border-y-2"
							aria-current={$page.url.pathname === link.link}
						>
							<span class="text-sm font-medium">{link.text}</span>
							<span
								class="fa-solid fa-angle-down shrink-0 text-logoBackgroundBlue transition duration-300 group-open:-rotate-180"
							/>
						</summary>
						<ul class="mt-2 space-y-1 px-4 text-gray-500">
							<li>
								<a
									class="block px-4 py-2 text-sm hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
									href={link.link}
									aria-current={$page.url.pathname === link.link}>All</a
								>
							</li>
							{#if link.subLinks}
								{#each link.subLinks as subLink}
									<li>
										<a
											class="block px-4 py-2 text-sm hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
											href={`${link.link}?${link.urlParam}=${subLink.replace(' ', '%20')}`}
											aria-current={$page.url.pathname ===
												`${link.link}?${link.urlParam}=${subLink.replace(' ', '%20')}`}
											>{subLink}</a
										>
									</li>
								{/each}
							{/if}
							<div role="separator" class="h-px w-full bg-gray-200"></div>
							<li
								class="my-auto hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
							>
								<a
									class="aria-current: block px-4 py-2 text-sm"
									href="/corporateOrders"
									aria-current={$page.url.pathname === '/corporateOrders'}
									>Corporate Orders</a
								>
							</li>
							<li
								class="my-auto hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
							>
								<a
									class="aria-current: block px-4 py-2 text-sm"
									href="/customCreations"
									aria-current={$page.url.pathname === '/customCreations'}
									>Custom Creations</a
								>
							</li>
							<li
								class="my-auto hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
							>
								<a
									class="aria-current: block px-4 py-2 text-sm"
									href="/specialOccasions"
									aria-current={$page.url.pathname === '/specialOccasions'}
									>Special Occasions</a
								>
							</li>
						</ul>
					</details>
				{/if}
			</li>
		{/each}
	</ul>
</nav>
